import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { ViewAsControl } from '@/components/admin/ViewAsControl'
import { TwitchServerSettings } from '@/components/twitch/TwitchServerSettings'
import { Button, SectionCard } from '@/components/ui'
import { useAuthStore } from '@/stores/auth-store'

export const Route = createFileRoute('/admin/super-admin')({
  beforeLoad: () => {
    if (useAuthStore.getState().user?.role !== 'super_admin') {
      throw redirect({ to: '/admin', replace: true })
    }
  },
  component: SuperAdminPage,
})

function SuperAdminPage() {
  return <div data-testid="admin-server-settings" className="grid items-start gap-6 xl:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
    <SectionCard title="View another account" description="Choose a broadcaster, then return to the studio to work in their account. Server settings here always apply to the whole server.">
      <div className="space-y-4">
        <ViewAsControl />
        <Button asChild variant="outline"><Link to="/admin">Open studio</Link></Button>
      </div>
    </SectionCard>
    <TwitchServerSettings />
  </div>
}
